import TableCellBodyUnstyled from 'pages/ReportPages/components/TableCellBody'
import styled from 'styled-components'

export const TableCellBody = styled(TableCellBodyUnstyled)`
  width: 160px;
`
